import { render, staticRenderFns } from "./p15.vue?vue&type=template&id=54a5ed58&scoped=true&"
import script from "./p15.vue?vue&type=script&lang=js&"
export * from "./p15.vue?vue&type=script&lang=js&"
import style0 from "./p15.vue?vue&type=style&index=0&id=54a5ed58&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5ed58",
  null
  
)

export default component.exports